import type { QueryClient } from '@tanstack/react-query';

/**
 * Queries backing the customer-level timeline. Every note domain rolls up to the customer, so a note
 * added, edited or deleted anywhere invalidates these as well as its own entity's queries.
 */
export const CUSTOMER_TIMELINE_QUERY_KEYS = ['customer-recent-activities', 'customer-canonical-notes'] as const;

export function invalidateCustomerTimeline(queryClient: QueryClient): void {
  for (const key of CUSTOMER_TIMELINE_QUERY_KEYS) {
    queryClient.invalidateQueries({ queryKey: [key] });
  }
}
